import React, { useState } from 'react';
import SectionHeading from './SectionHeading';

const ContactForm = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [subject, setSubject] = useState('');
    const [message,setMessage] = useState('');

    const [notification, setNotification] = useState(null);
    const [sending, setSending] = useState(false);

   

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true)


        // Prepare the data to send
        const formData = {
            type: "CONTACT",
            full_name: name,
            email: email,
            subject: subject,
            message: message,
        };


        try {
            // Make the API call
            const response = await fetch('https://x8ki-letl-twmt.n7.xano.io/api:rsIn_jW5/CONTACT', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setNotification('Form submitted successfully!');
                // Clear the form
                setName('');
                setEmail('');
                setMessage("");
                setSubject("");
                setIsChecked(false);
            } else {
                setNotification('Failed to submit the form. Please try again.');
            }
        } catch (error) {
            setNotification('An error occurred. Please try again later.');
        }

        setSending(false)
    };

    return (
        <div className="contact-form drop-shadow-2" >
            <div  className="contact-form-wrapper" >
                <SectionHeading
                    subHeading='CONTÁCTANOS'
                    additionalClasses='section-heading-2 center'
                />
                <form onSubmit={handleSubmit}>
                    <div className="form-floating">
                        <input 
                        className="input form-control" 
                        id="name-field" 
                        type="text" 
                        placeholder="Nombre completo" 
                        value={name}
                        onChange={(e) => { setName(e.target.value) }}
                        required
                        disabled={sending}
                        />
                        <label htmlFor="name-field">Nombre completo</label>
                    </div>
                    <div className="form-floating">
                        <input 
                        className="input form-control" 
                        id="email-field" 
                        type="text" 
                        placeholder="Dirección de correo electrónico" 
                        value={email}
                        onChange={(e) => { setEmail(e.target.value) }}
                        required
                        disabled={sending}
                        />
                        <label htmlFor="email-field">Dirección de correo electrónico</label>
                    </div>
                    <div className="form-floating">
                        <input 
                        className="input form-control" 
                        id="subject-field" 
                        type="text" 
                        placeholder="Asunto" 
                        value={subject}
                        onChange={(e) => { setSubject(e.target.value) }}
                        required
                        disabled={sending}
                        />
                        <label htmlFor="subject-field">Asunto</label>
                    </div>
                    <div className="form-floating">
                        <textarea
                            className="form-control"
                            id="message-field"
                            placeholder="Escribe tu mensaje aquí..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            required
                            disabled={sending}
                            style={{ height: '150px' }} // Adjust the height as needed
                        />
                        <label htmlFor="message-field">Mensaje</label>
                    </div>
             
                 
                    <button type="submit" className="button button-3" disabled={sending||notification}>
                        <span className="button-inner">
                            <span className="button-content">
                                <span className="text">Enviar</span>
                            </span>
                        </span>
                    </button>
                </form>
                {notification && 
                 <h4 class="mt-5" style={{textAlign:"center"}}>Pronto nos pondremos en contacto contigo!</h4>
                }
            </div>
        </div>
    );
};

export default ContactForm;
